import React from 'react';
import { Box, Button, Dialog, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ErrorIcon from '../../public/ErrorIcon.svg';
import { constants } from '@/constants';
import { useThemeDetails } from './ThemeDetailsContext';
export default function ErrorModal(_ref) {
    var open = _ref.open, onClose = _ref.onClose, title = _ref.title, description = _ref.description;
    var theme = useTheme();
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        PaperProps: {
            sx: {
                backgroundColor: theme.palette.background.paper,
                borderRadius: '24px',
                boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.12), 0px 4px 8px 0px rgba(0,0,0,0.14)',
                padding: 0,
                width: '500px',
                maxHeight: '380px',
                overflow: 'hidden'
            }
        },
        sx: {
            '& .MuiDialog-paper': {
                overflow: 'hidden'
            },
            '& .MuiDialog-container': {
                overflow: 'hidden'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: '16px',
            pt: '24px',
            pb: 0,
            width: '100%',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        spacing: 2,
        alignItems: "center",
        justifyContent: "center",
        sx: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: (stateImages === null || stateImages === void 0 ? void 0 : stateImages.Error) || ErrorIcon,
        alt: "Error Icon",
        sx: {
            width: stateImages !== null && stateImages !== void 0 && stateImages.Error ? 117 : 78,
            height: stateImages !== null && stateImages !== void 0 && stateImages.Error ? 117 : 78,
            display: 'block'
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        spacing: 1.5,
        alignItems: "center",
        justifyContent: "center",
        sx: {
            width: '100%',
            maxWidth: '436px',
            color: theme.palette.text.primary,
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: '0.15px',
            color: theme.palette.text.primary,
            width: '100%'
        }
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            color: theme.palette.text.primary,
            width: '100%',
            whiteSpace: 'pre-wrap'
        }
    }, description)))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: '24px',
            py: '16px',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        onClick: onClose,
        sx: {
            height: '44px',
            px: '16px',
            py: '8px',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "button",
        sx: {
            fontSize: '16px',
            lineHeight: '26.88px',
            letterSpacing: '0.4px',
            textTransform: 'none'
        }
    }, constants.feedback_error_modal_button_close))));
}
